import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToHMS',
})
export class SecondsToHMSPipe implements PipeTransform {
  transform(
    seconds: number | undefined,
    format: string = 'hms'
  ): string | undefined {
    if (!seconds) return undefined;
    let hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    let minutes = Math.floor(seconds / 60);
    seconds = Math.floor(seconds % 60);
    switch (format) {
      case 'hms':
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
          .toString()
          .padStart(2, '0')}`;
      case 'hm':
        return `${hours}:${minutes.toString().padStart(2, '0')}`;
      case 'ms':
        minutes += hours * 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
      default:
        return '';
    }
  }
}
